function Search_algolia_instantsearch(element) {
  this.loaded = false;
  this.algoliaInstantsearchVersion = element.dataset.algoliaInstantsearchVersion;


  /**
   * init decorator
   */
  this.init = function() {
    console.log("Search_algolia_instantsearch init...");

    if (!this.loaded) {
      this.loadAlgoliaLibraries();
    }

    this.loaded = true;
  };


  /**
   * inject remote CDN script used for the algolia instantsearch client
   */
  this.loadAlgoliaLibraries = function () {
    var instantsearch = document.createElement('script');
    instantsearch.type = 'text/javascript';
    instantsearch.src = 'https://cdn.jsdelivr.net/npm/instantsearch.js@' + this.algoliaInstantsearchVersion;

    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(instantsearch, s);
  };
}
